import { createRoot } from 'react-dom/client';
import Root from './Root';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import StoreProvider from './store';
import TranslationProvider from './utils/translations/Config';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Toast from './features/general/components/Toast';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../node_modules/bootstrap/dist/css/bootstrap.css';
// import './styles/bootstrap.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
import './styles/base.scss';
import { LicenseInfo } from '@mui/x-license';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
// import { ThemeProvider } from 'react-bootstrap';

const PASSPHRASE = 'ps_mui_enc_v1';
const SALT = 'portalstation_salt_v1';

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

async function deriveKeyFromPassphrase(passphrase: string): Promise<CryptoKey> {
  const enc = new TextEncoder();
  const passBuf = enc.encode(passphrase);
  const salt = enc.encode(SALT);
  const baseKey = await crypto.subtle.importKey('raw', passBuf, 'PBKDF2', false, ['deriveKey']);
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt, iterations: 100000, hash: 'SHA-256' },
    baseKey,
    { name: 'AES-GCM', length: 256 },
    false,
    ['decrypt']
  );
}

async function decryptLicense(encPayload: { c: string; iv: string; tag: string }, passphrase: string): Promise<string> {
  const ctBuf = base64ToArrayBuffer(encPayload.c);
  const ivBuf = base64ToArrayBuffer(encPayload.iv);
  const tagBuf = base64ToArrayBuffer(encPayload.tag);
  const ct = new Uint8Array(ctBuf);
  const combined = new Uint8Array(ct.length + tagBuf.byteLength);
  combined.set(ct, 0);
  combined.set(new Uint8Array(tagBuf), ct.length);
  const key = await deriveKeyFromPassphrase(passphrase);
  const plainBuf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: ivBuf }, key, combined.buffer);
  return new TextDecoder().decode(plainBuf);
}

// Load /env.js if window.__ENV__ is not present
function ensureEnvLoaded(): Promise<void> {
  if ((window as any).__ENV__) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = '/env.js';
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load /env.js'));
    document.head.appendChild(s);
  });
}

(async () => {
  try {
    await ensureEnvLoaded(); // ensure window.__ENV__ is available
    const enc = (window as any).__ENV__?.MUI_X_LICENSE_KEY_ENC;
    if (enc) {
      const license = await decryptLicense(enc, PASSPHRASE);
      if (license) {
        LicenseInfo.setLicenseKey(license);
        return;
      }
    }
    const fallback = process.env.REACT_APP_MUI_X_LICENSE_KEY || '';
    if (fallback) LicenseInfo.setLicenseKey(fallback);
  } catch {
    const fallback = process.env.REACT_APP_MUI_X_LICENSE_KEY || '';
    if (fallback) LicenseInfo.setLicenseKey(fallback);
  }
})();


library.add(far, fas);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  // <React.StrictMode>
  <StoreProvider>
    <TranslationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Toast />
        <Root />
      </LocalizationProvider>
    </TranslationProvider>
  </StoreProvider>
  // </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
